import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import Image from "next/image"
import { CSVLink } from "react-csv"
import downArrow from "@/public/icons/down-arrow-sort.svg"
import downloadIcon from "@/public/icons/download-icon.svg"
import { getAbandonedCarts, selectCartState } from "@/store/features/cartSlice"
import { setCustomerCartId } from "@/utils/cart"
import { getCart } from "@/store/features/cartSlice"
import CartPagination from "@/components/cart/Pagination/index"
import Style from "@/components/cart/AbandonedCarts/index.module.scss"
import ArrowRightIcon from "@/public/icons/arrow-right.svg"
import Link from "next/link"
import { DEFAULT_PRODUCT_COUNT_PLP, PRODUCTS_PER_PAGE } from "@/constants"
import { NumericFormat } from "react-number-format"
import ArrowLeft from "@/public/icons/back-arrow.svg"
import { showToast } from "@/store/features/genericSlice"

const AbandonedCarts = ({
  staticTexts,
  onClick,
  currencySign,
  loadAbandonedCart,
}) => {
  const { abandonedCarts = [] } = useSelector(selectCartState)
  const dispatch = useDispatch()
  const [sort, setSort] = useState("desc")
  const [headers, setHeaders] = useState([
    { label: "Cart ID", key: "collabCartId" },
    { label: "Cart Creation", key: "createtime" },
    { label: "Customer Email", key: "initiatedBy" },
    { label: "Customer Name", key: "customerName" },
  ])

  useEffect(() => {
    dispatch(getAbandonedCarts())
  }, [])
  const [totalData, setTotalData] = useState(0)
  const [totalResults, setTotalResults] = useState(0)
  const [tableData, setTableData] = useState([])
  const [curRows, setCurRows] = useState(DEFAULT_PRODUCT_COUNT_PLP)
  const [paginationState, setPaginationState] = useState({
    rows: DEFAULT_PRODUCT_COUNT_PLP,
    start: 0,
  })

  useEffect(() => {
    let arrayForSort = [...abandonedCarts]
    if (arrayForSort.length) {
      arrayForSort.sort((a, b) => {
        return +new Date(b.createtime) - +new Date(a.createtime)
      })
    }
    setTotalData(arrayForSort)
    setTableData(arrayForSort.slice(0, DEFAULT_PRODUCT_COUNT_PLP))
    setTotalResults(arrayForSort.length)
  }, [abandonedCarts])

  useEffect(() => {
    if (totalData.length) {
      setTableData(
        totalData.slice(
          paginationState.start,
          paginationState.start + paginationState.rows
        )
      )
    }
  }, [paginationState, totalData])
  const displayPrint = true
  const productsPerPage = PRODUCTS_PER_PAGE
  const { rows, start } = paginationState

  useEffect(() => {
    tableData.forEach(item => {
      if (item?.lineitems.length > 0) {
        item.lineitems.forEach((item, i) => {
          const header = { label: "SKU Code", key: `lineitems[${i}].sku` }
          if (!headers.find(i => i.key === header.key)) {
            headers.push(header)
            headers.push({ label: "Line Item Qty", key: `lineitems[${i}].qty` })
            headers.push({
              label: "Item MRP",
              key: `lineitems[${i}].itemMRP`,
            })
            headers.push({
              label: "Item Seling Price",
              key: `lineitems[${i}].itemSP`,
            })
          }
        })
      }
    })
    if (!headers.find(i => i.label === "Pincode")) {
      headers.push(
        {
          label: "Pincode",
          key: `shippingInfo.pincode`,
        },
        {
          label: "City",
          key: `shippingInfo.city`,
        },
        {
          label: "State",
          key: `shippingInfo.state`,
        },
        {
          label: "Device Type",
          key: "deviceType",
        }
      )
    }
    setHeaders(headers)
  }, [tableData])

  const handleLoadCart = cart => {
    if (cart.recoveredStatus === false) {
      dispatch(getCart({ klId: cart.collabCartId }))
        .unwrap()
        .then(res => {
          setCustomerCartId(res.id)
          onClick()
          loadAbandonedCart(true)
          window.scrollTo({ top: 0, behavior: "smooth" })
        })
        .catch(error => {
          dispatch(
            showToast({
              message: "Cart is not available.",
              isVisible: true,
            })
          )
          console.error("error", error)
        })
    }
  }

  const returnToCart = () => {
    onClick()
  }

  const onLoadMore = () => {
    setPaginationState(state => ({ ...state, rows: rows + rows }))
  }

  const onRows = rows => {
    setCurRows(rows)
    setPaginationState({ rows, start: 0 })
  }

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    document.getElementById(`kf-product-list-tile-details-0`)?.focus()
  }

  const onSort = () => {
    const sortOrder = sort === "asc" ? "desc" : "asc"
    let arrayForSort = [...totalData]
    if (sortOrder === "desc") {
      arrayForSort.sort((a, b) => {
        return +new Date(b.createtime) - +new Date(a.createtime)
      })
    } else {
      arrayForSort.sort((a, b) => {
        return +new Date(a.createtime) - +new Date(b.createtime)
      })
    }
    setSort(sortOrder)
    setTotalData(arrayForSort)
  }

  return (
    <section className={Style.AbandonedCarts}>
      <div className="back-to-cart">
        <img
          src={ArrowLeft?.src}
          alt="Back"
          className="pr-10 pb-5"
          height="20"
          width="40"
        />
        <button className="back-to-cart-text" onClick={returnToCart}>
          Back to Cart
        </button>
      </div>
      <div className="header">
        <h2 className="heading">Abandoned Carts</h2>
        <div className="Button_buttonWrapper__9Vvy_ kf-react-button button  p-4 large ghost ">
          <CSVLink
            data={tableData}
            headers={headers}
            filename={"Abandoned cart report.csv"}
          >
            <button
              className={"kf-react-button button  p-3 large ghost"}
              role="button"
              tabIndex="0"
              label={``}
              type="ghost"
            >
              <Image
                src={downloadIcon.src}
                width={20}
                height={20}
                alt="arrow"
                className="pr-5"
              />
              Export ({tableData.length}) Carts
            </button>
          </CSVLink>
        </div>
      </div>
      <table className="table custom-table-rwd">
        <thead>
          <tr>
            <th>Cart Id</th>
            <th>Customer</th>
            <th onClick={onSort}>
              Date
              {sort === "desc" ? (
                <img
                  className={`${"pl-10"}`}
                  aria-hidden="true"
                  src={downArrow.src}
                  alt={"down-arrow"}
                />
              ) : null}
            </th>
            <th>Status</th>
            <th>Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tableData.map(cart => (
            <tr key={cart.createtime} onClick={() => handleLoadCart(cart)}>
              <td>
                <span className="underline">{cart.collabCartId}</span>
              </td>
              <td>{cart.customerName}</td>
              <td>{moment(cart.createtime).format("lll")}</td>
              <td className="mobile-label">
                <div
                  className={`border ${
                    cart.recoveredStatus === true
                      ? "active"
                      : cart.recoveredStatus === false
                      ? "label"
                      : ""
                  }`}
                >
                  {cart.recoveredStatus === true
                    ? "Recovered"
                    : cart.recoveredStatus === false
                    ? "Not Recovered"
                    : ""}
                </div>
              </td>
              <td className="mobile-price">
                <NumericFormat
                  className="cart-item__total-price hide-mobile-price"
                  value={cart.cartValue / 100}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  thousandsGroupStyle={"lakh"}
                />
              </td>
              <td className="mobile-arrownav">
                {cart.recoveredStatus === false && (
                  <Image
                    src={ArrowRightIcon.src}
                    width={20}
                    height={20}
                    alt="arrow"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <CartPagination
        page={"cart"}
        {...{
          totalResults,
          productsPerPage,
          onRows,
          displayPrint,
          staticTexts,
          curRows,
          handleBackToTop,
          onLoadMore,
        }}
      />
    </section>
  )
}

export default AbandonedCarts
